import { render } from "./Item.vue?vue&type=template&id=05e67d8a&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Item.vue?vue&type=style&index=0&id=05e67d8a&lang=scss&module=true"
cssModules["$style"] = style0
import "./Item.vue?vue&type=style&index=1&id=05e67d8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-05e67d8a"]])

export default __exports__